import React from "react";
import { Link } from "react-router-dom";
import { ShieldStar } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="mt-32 border-t border-white/5 bg-[#050505] relative z-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-9 h-9 border border-[#FFD700] rotate-45 flex items-center justify-center">
              <ShieldStar size={18} weight="duotone" className="text-[#FFD700] -rotate-45" />
            </div>
            <div>
              <div className="heading-display text-base">EIGOO PROVISIONS</div>
              <div className="overline text-[0.55rem]">provisions.eigooinc.net</div>
            </div>
          </div>
          <p className="text-sm text-white/60 max-w-md leading-relaxed font-light">
            The premier shipyard for Sovereign digital products. Industrial-grade operational
            intelligence packaged for the elite operator class.
          </p>
        </div>

        <div>
          <div className="overline mb-4">Sectors</div>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/catalog?sector=flagship" className="hover:text-[#FFD700]">Flagship Arsenal</Link></li>
            <li><Link to="/catalog?sector=starter" className="hover:text-[#FFD700]">Sovereign Starters</Link></li>
            <li><Link to="/blueprint" className="hover:text-[#FFD700]">Blueprint Engine</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Fleet</div>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/commander" className="hover:text-[#FFD700]">Commander Deck</Link></li>
            <li><a href="mailto:fleet@eigooinc.net" className="hover:text-[#FFD700]">Contact Bridge</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center font-mono text-[0.65rem] tracking-[0.2em] uppercase text-white/30">
        EIGOO Inc. // Sovereign Provisions // {new Date().getFullYear()}
      </div>
    </footer>
  );
}
